// extracted by mini-css-extract-plugin
export default {"background":"style_background__4-BZb","container":"style_container__GCm5r","circle":"style_circle__pFXXU","checkIcon":"style_checkIcon__26tmV"};